import { Link, useLocation, useNavigate } from "react-router-dom";
import { Flame, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";
import { SearchDropdown } from "./SearchDropdown";

const ANNOUNCEMENTS = [
  "FREE SHIPPING OVER $150",
  "CODE: REBEL15 — 15% OFF",
  "NEW DROP LIVE NOW",
  "WEAR THE REBELLION",
];

export const Header = () => {
  const { count, setDrawerOpen } = useCart();
  const location = useLocation();
  const navigate = useNavigate();

  const goManifesto = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      document.getElementById("manifesto")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40" data-testid="site-header">
      <div className="bg-[#E05A36] text-[#0C0A09] overflow-hidden py-1.5" data-testid="announcement-bar">
        <div className="flex whitespace-nowrap animate-marquee-fast">
          {[0, 1].map((half) => (
            <div key={half} className="flex shrink-0">
              {[...ANNOUNCEMENTS, ...ANNOUNCEMENTS, ...ANNOUNCEMENTS].map((a, i) => (
                <span key={`${half}-${i}`} className="mx-8 text-[11px] font-mono font-bold uppercase tracking-[0.2em]">
                  {a} <span className="ml-8">•</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="bg-[#0C0A09]/85 backdrop-blur-xl border-b border-[#2C2623]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
            <Flame className="w-6 h-6 text-[#E05A36] group-hover:scale-110 transition-transform" />
            <span className="font-display font-extrabold text-lg tracking-tight uppercase">
              Popular<span className="text-[#E05A36]">Rebelz</span>
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-xs font-mono uppercase tracking-[0.2em] text-[#B8AEA5]">
            <Link to="/shop" className="hover:text-[#E05A36] transition-colors" data-testid="nav-shop-link">Store</Link>
            <button onClick={goManifesto} className="hover:text-[#E05A36] transition-colors uppercase tracking-[0.2em]" data-testid="nav-manifesto-link">
              Manifesto
            </button>
            <Link to="/admin" className="hover:text-[#E05A36] transition-colors" data-testid="nav-admin-link">Admin</Link>
          </nav>
          <div className="flex items-center gap-2">
            <SearchDropdown />
            <button
              onClick={() => setDrawerOpen(true)}
              className="relative flex items-center gap-2 border border-[#2C2623] hover:border-[#E05A36] px-4 py-2 transition-colors"
              data-testid="cart-open-button"
            >
              <ShoppingBag className="w-4 h-4" />
              <span className="text-xs font-mono uppercase tracking-widest hidden sm:inline">Cart</span>
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#E05A36] text-[#0C0A09] text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full" data-testid="cart-count-badge">
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
